import type { CampaignFull } from "./rest/types";
import { getUrl } from "./urls";

function getRawTagValue(tagName: string): string | null {
  const el: HTMLMetaElement | null = document.querySelector(
    `meta[name=${tagName}]`
  );
  if (!el) {
    return null;
  }
  return el.content;
}

function getRawTagValueAlways(tagName: string): string {
  const raw = getRawTagValue(tagName);
  if (!raw) {
    throw new Error(`<meta name="${tagName}" must be in document`);
  }
  return raw;
}

function getCampaignObject(): CampaignFull {
  const raw = getRawTagValueAlways("umg-campaign");
  return JSON.parse(raw);
}

function canonicalEnvironment(env: string): "staging" | "production" | "local" {
  if (env === "staging" || env === "production" || env === "local") {
    return env;
  } else if (env === "live" || env === "prod") {
    return "production";
  }
  throw new Error(`Invalid environment: ${env}`);
}

export function parseUmgTags(): {
  campaign: CampaignFull;
  defaultApiHost: string;
  cmsEnvironment: "staging" | "production" | "local";
} {
  const cmsEnv = canonicalEnvironment(
    getRawTagValueAlways("umg-cms-environment")
  );
  return {
    campaign: getCampaignObject(),
    defaultApiHost: getUrl(cmsEnv),
    cmsEnvironment: cmsEnv,
  };
}
